import { render, staticRenderFns } from "./VerCuponesPendientes.vue?vue&type=template&id=71c8f79c&"
import script from "./VerCuponesPendientes.vue?vue&type=script&lang=js&"
export * from "./VerCuponesPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports